import { menu } from '@material-tailwind/react';
import { STATE_SELECTION_ENABLED, ADMINTAB, ASSISTANTADMINTAB, initialFilterValue, markNotificationAsViewedApi, profCasesPanelItems } from 'Constants'
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

// Title-case the all-caps menu labels for the marketplace nav ("AVAILABLE CASES" -> "Available Cases")
const toTitle = (label) => (label || '').toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());

// Case List design: the filters a user applies stay applied when they switch
// between Available / Active / Closed / Teamup. So the filters are only set up
// (saved defaults for Available, empty elsewhere) the first time per user.
const filtersSetUpFor = new Set();

function HeaderMenuItems({menuItems, fontSize, userInfo, showCount = null, renderHorizontal = true, setOpenMenu, dark = false, variant = null}) {
    // 'marketplace' = attorney nav (design 18c); 'admin' = same look plus a gold underline on the active tab (design 19a)
    const marketplace = variant === 'marketplace' || variant === 'admin';
    const adminNav = variant === 'admin';
    const {selectedMenuItem, setSelectedMenuItem, setFilters, userDetails, makeApiCallFunc,
        setUpdateLoggedinData

    } = useContext(Context);
    const {setPanel} = useParams();
    const navigate = useNavigate();
    const {notificationCount, offset, setOffset} = useContext(Context);
    let count = notificationCount;
    const [fontSizeClass, setFontSizeClass] = useState("10.5px");
    const [hoverFontSize, setHoverFontSize] = useState("14px");

    const [activeCasesCount, setActiveCasesCount] = useState(0);

  
    useEffect(() => {
    setFontSizeClass(fontSize === 2 ? "16px" : "12.5px");
    setHoverFontSize(fontSize === 2 ? "16.5px" : "14px");
    },[fontSize])
    useEffect(() => {
        if(showCount && userDetails?.casesRel?.length > 0 )
        { 
            let casesCount = userDetails?.casesRel?.reduce((acc, item) => {
            return acc + (item?.caseStatus === "approved" ? 1 : 0);
        }, 0);
            

            setActiveCasesCount(casesCount);
            
            let closedCasesCount = userDetails?.casesRel?.reduce((acc, item) => {
                return acc + (item?.caseStatus === "closed" ? 1 : 0
                );
            }, 0);
            console.log("closed case count"+closedCasesCount)
            menuItems.map((item) => item.menuName === "closedCases" ? item.closedCount = closedCasesCount : 0);

            menuItems.map((item) => item.menuName === "activeCases" ? item.activecount = casesCount : 0);
            console.log(menuItems)

        }
    },[showCount, userDetails])
    menuItems.map((item) => item.menuName === "notifications" ? item.count = count : 0);
   
    useEffect(() => {
        // which section the URL points at
        if(setPanel)
        {
            menuItems.forEach((item) => {
                if(item.menuName === setPanel) setSelectedMenuItem(item.key);
            });
        }
        // filters: set up once per user, then left alone (kept across sections)
        const who = userInfo?._id || userDetails?._id || 'anon';
        if (filtersSetUpFor.has(who)) return;
        filtersSetUpFor.add(who);
        const current = setPanel ? menuItems.find((item) => item.menuName === setPanel) : null;
        // law firms start with no filters, so cases a client saved their firm on are never hidden
        const firmAccount = (userInfo || userDetails)?.role === 5;
        if ((current && parseInt(current?.key) !== 1) || firmAccount)
        {
            setFilters(initialFilterValue);
        }
        else
        {
            setFilters({
               ...initialFilterValue,
                "caseType": userInfo?.casePref ? userInfo?.casePref : [],
                "incidentState": STATE_SELECTION_ENABLED && userInfo?.statePref ? userInfo?.statePref : [],
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[setPanel]);
  return (
    <div className={marketplace ? "flex items-center z-30 w-max" : (" ml-2  lg:flex font-bold   z-30 flex w-full " + (renderHorizontal ? " flex-row" : " flex-col gap-4"))} style={marketplace ? {gap: adminNav ? '22px' : '30px'} : undefined}>
       
        {
            menuItems.map((item, index) => {
                return (
                    <div key={item?.key} 
                    aria-disabled={item?.comingSoon ? true : undefined}
                    title={item?.comingSoon ? 'Coming soon' : undefined}
                    onClick={()=>
                        {
                        if(item?.comingSoon) return; // not released yet
                        if(setOpenMenu) setOpenMenu(false);
                        // applied filters are kept when switching sections (Case List design)
                        setSelectedMenuItem(item?.key);
                        setOffset(0);
                        navigate(item?.link)
                    }
                    }
                    style={marketplace ? (adminNav ? {
                        ...(parseInt(selectedMenuItem) === parseInt(item?.key)
                            ? {font:"600 12px/1 'IBM Plex Sans',sans-serif", color:'#f7f4ed'}
                            : {font:"500 12px/1 'IBM Plex Sans',sans-serif", color:'rgba(247,244,237,.55)'}),
                        letterSpacing: '.04em',
                        paddingBottom:'2px', borderBottom: parseInt(selectedMenuItem) === parseInt(item?.key) ? '2px solid #c9a26a' : '2px solid transparent',
                    } : {
                        // Case List design: 600 13.5px, 24px/21px padding, 3px gold underline when active
                        font:"600 13.5px/1 'IBM Plex Sans',sans-serif",
                        color: parseInt(selectedMenuItem) === parseInt(item?.key) ? '#fffdf8' : 'rgba(247,244,237,.6)',
                        padding:'24px 0 21px',
                        borderBottom: parseInt(selectedMenuItem) === parseInt(item?.key) ? '3px solid #c9a26a' : '3px solid transparent',
                        whiteSpace:'nowrap',
                    }) : undefined}
                    className={marketplace ? ("w-max relative flex items-center transition-colors " + (item?.comingSoon ? "cursor-default" : "cursor-pointer hover:!text-[#f7f4ed]")) : "w-max text-xs lg:text-[14px] relative cursor-pointer mr-1 p-1 lg:p-2  flex items-center justify-center hover:text-["+hoverFontSize+"] transition-all duration-100 hover:rounded ease-in-out " + (dark
                        ? (parseInt(selectedMenuItem) === parseInt(item?.key) ? ' text-ivory bg-white/10 hover:bg-white/10' : ' text-cream/70 hover:bg-white/10')
                        : (parseInt(selectedMenuItem) === parseInt(item?.key) ? ' text-sky-600 bg-sky-50 hover:bg-gray-100' : ' text-gray-600 hover:bg-gray-100'))}>
                    <span className={item?.comingSoon ? 'opacity-50' : undefined}>{marketplace ? toTitle(item?.menu) : item?.menu}</span>
                    {item?.comingSoon &&
                        <span className='ml-2 font-plexmono font-semibold text-[9.5px] leading-none tracking-[.08em] uppercase rounded-[9px] py-[3px] px-1.5 bg-gold/[.18] text-gold'>Soon</span>}
                    {item?.activecount && item?.activecount !== 0 && !userDetails.isActiveNotificationViewed ?
                        <div className={marketplace ? ('w-2 h-2 absolute -right-2.5 animate-pulse rounded-full bg-[#e5654f] ring-2 ring-navy' + (adminNav ? ' -top-0.5' : ' top-[20px]')) : 'w-2 h-2 absolute lg:top-2 top-[-1px] right-[-2px] lg:right-[2.5px] animate-pulse  rounded-full bg-red-700'}></div>
                        :
                        null
                    }
                    {item?.closedCount && item?.closedCount !== 0 &&  !userDetails.isClosedNotificationViewed ?
                        <div className={marketplace ? ('w-2 h-2 absolute -right-2.5 animate-pulse rounded-full bg-[#e5654f] ring-2 ring-navy' + (adminNav ? ' -top-0.5' : ' top-[20px]')) : 'w-2 h-2 absolute lg:top-2 top-[-1px] right-[-2px] lg:right-[2.5px] animate-pulse  rounded-full bg-red-700'}></div>
                        :
                        null
                    }
                    {item?.count && item?.count !== 0 ? 
                    <div className={marketplace ? 'ml-1.5 w-max' : ('rounded ml-2 px-2 h-max w-max lg:text-sm text-xs text-white' + (parseInt(selectedMenuItem) === parseInt(item?.key) ? ' bg-green-600' : ' bg-sky-600'))}
                    style={marketplace ? {font:"600 10px/1 'IBM Plex Mono',monospace", padding:'3px 6px', borderRadius:'9px', background:'#c9a26a', color:'#14213d'} : undefined}>
                    {item.count} 
                    </div>
                    : null}
                    </div>
                )
            })
        }
    </div>
  )
}

export default HeaderMenuItems